import { useEffect, useLayoutEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box,   Typography, useMediaQuery } from '@mui/material';

// project-imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { DashboardMenu } from 'menu-items/dashboard';

import { useSelector } from 'store';
import useConfig from 'hooks/useConfig';
import { HORIZONTAL_MAX_ITEM } from 'config';

// types
import { NavItemType } from 'types/menu';
import { LAYOUT_CONST } from 'types/config';
import NavItem from './NavItem';
import {useLocation} from "react-router";
import TabLayout from './TabLayout';


// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
  const theme = useTheme();

  const downLG = useMediaQuery(theme.breakpoints.down('lg'));

  const { menuOrientation,themeLayout } = useConfig();
  const { drawerOpen } = useSelector((state) => state.menu);
  const { pathname } = useLocation();

  const [selectedItems, setSelectedItems] = useState<string | undefined>('');
  const [selectedLevel, setSelectedLevel] = useState<number>(0);
  const [menuItems, setMenuItems] = useState<{ items: NavItemType[] }>({ items: [] });
  const [selectedGroup, setSelectedGroup] = useState<any | undefined>(menuItems?.items[0]);

  useEffect(() => {
    handlerMenuItem();
    // eslint-disable-next-line
  }, []);
  useLayoutEffect(() => {
    setMenuItems(menuItem);
    // eslint-disable-next-line
  }, [menuItem]);

  useEffect(() => {
    menuItems.items.map(value => {
      if(value.url?.includes(pathname.split('/')[1])){
        setSelectedGroup(value);
      }
    })
    if(!selectedGroup){
      setSelectedGroup(menuItems.items[0]);
    }
  })

  let getDash = DashboardMenu();
  const handlerMenuItem = () => {
    const isFound = menuItem.items.some((element) => {
      if (element.id === 'nl-dashboard') {
        return true;
      }
      return false;
    });

    if (getDash?.id !== undefined && !isFound) {
      menuItem.items.splice(0, 0, getDash);
      setMenuItems(menuItem);
    }
  };

  const isHorizontal = menuOrientation === LAYOUT_CONST.HORIZONTAL_LAYOUT && !downLG;

  const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
  let lastItemIndex = menuItems.items.length - 1;
  let remItems: NavItemType[] = [];
  let lastItemId: string='0';

  if (lastItem && lastItem < menuItems.items.length) {
    lastItemId = menuItems.items[lastItem - 1].id!;
    lastItemIndex = lastItem - 1;
    remItems = menuItems.items.slice(lastItem - 1, menuItems.items.length).map((item) => ({
      title: item.title,
      elements: item.children,
      icon: item.icon
    }));
  }

  const navGroups = menuItems.items.slice(0, lastItemIndex + 1).map((item) => {
    switch (item.type) {
      case 'group':
        return (
          <NavGroup
            key={item.id}
            setSelectedItems={setSelectedItems}
            setSelectedLevel={setSelectedLevel}
            selectedLevel={selectedLevel}
            selectedItems={selectedItems}
            lastItem={lastItem!}
            remItems={remItems}
            lastItemId={lastItemId}
            item={item}
          />
        );
      case 'item':
        return <NavItem key={item.id} item={item} level={1} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });



  // console.log(menuItems);
  
  return (
    <Box
      sx={{
        pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
        '& > ul:first-of-type': { mt: 0 },
        display: isHorizontal ? { xs: 'block', lg: 'flex' } : 'block'
      }}
    >
      {(themeLayout=='tab')?
      <TabLayout menuItems={menuItems.items}
                 key={selectedGroup?.id}
                 setSelectedItems={setSelectedItems}
                 setSelectedLevel={setSelectedLevel}
                 selectedLevel={selectedLevel}
                 selectedItems={selectedItems}
                 lastItem={lastItem!}
                 remItems={remItems}
                 lastItemId={lastItemId}
                 item={selectedGroup}
      />
      :navGroups
    }
      {/* {navGroups} */}
    </Box>
  );
};

export default Navigation;
